// Application types

const CURRENCY = {
  LOADING_CURRENCY: "LOADING_CURRENCY",
  GET_ALL_CURRENCIES: "GET_ALL_CURRENCIES",
};
export default CURRENCY;
